var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.399,
    height: 49.399,
    viewBox: "0 0 49.399 49.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_361",
    "data-name": "Grupo 361",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_520",
    "data-name": "Caminho 520",
    d: "M1606.015,1043.037H1594a3.8,3.8,0,0,0-3.8,3.8v12.016a3.8,3.8,0,0,0,3.8,3.8h12.016a3.8,3.8,0,0,0,3.8-3.8v-12.016A3.8,3.8,0,0,0,1606.015,1043.037ZM1600,1060.425a7.586,7.586,0,1,1,7.586-7.586A7.595,7.595,0,0,1,1600,1060.425Zm7.209-13.325a1.421,1.421,0,1,1,1.421-1.421A1.422,1.422,0,0,1,1607.21,1047.1Z",
    transform: "translate(-1575.22 -1029.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_521",
    "data-name": "Caminho 521",
    d: "M1592.344,1012.089h-21.609a13.9,13.9,0,0,0-13.9,13.895v21.609a13.9,13.9,0,0,0,13.9,13.9h21.609a13.9,13.9,0,0,0,13.9-13.9v-21.609A13.9,13.9,0,0,0,1592.344,1012.089Zm.914,29.712a5.629,5.629,0,0,1-5.623,5.623h-12.016A5.629,5.629,0,0,1,1570,1041.8v-12.016a5.63,5.63,0,0,1,5.623-5.624h12.016a5.63,5.63,0,0,1,5.623,5.624Z",
    transform: "translate(-1556.84 -1012.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_522",
    "data-name": "Caminho 522",
    d: "M1605.189,1052.424a5.588,5.588,0,1,0,5.588,5.587A5.587,5.587,0,0,0,1605.189,1052.424Z",
    transform: "translate(-1580.409 -1034.314)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.09ac35121f4d5b411adf930f04c3286f.svg";
export { ForwardRef as ReactComponent };